// Typed event API — fires to Yandex.Metrika and GA4 together.
// Gated on NEXT_PUBLIC_YM_ID / NEXT_PUBLIC_GA4_ID env. On server (no window) all functions = no-op.

type YMEventParams = Record<string, string | number | boolean | undefined>;

declare global {
  interface Window {
    ym?: (id: number, action: string, ...args: unknown[]) => void;
    gtag?: (command: string, ...args: unknown[]) => void;
  }
}

const COUNTER_ID = Number(process.env.NEXT_PUBLIC_YM_ID || 0);
const GA4_ID = process.env.NEXT_PUBLIC_GA4_ID;

function reachGoal(target: string, params?: YMEventParams) {
  if (typeof window === 'undefined' || !window.ym || !COUNTER_ID) return;
  window.ym(COUNTER_ID, 'reachGoal', target, params);
}

function gtagEvent(name: string, params?: YMEventParams) {
  if (typeof window === 'undefined' || !window.gtag || !GA4_ID) return;
  window.gtag('event', name, params);
}

function fire(target: string, params?: YMEventParams) {
  reachGoal(target, params);
  gtagEvent(target, params);
}

export type CtaLocation =
  | 'hero_primary'
  | 'hero_secondary'
  | 'navbar'
  | 'sticky_mobile'
  | 'solution'
  | 'cases_repeat'
  | 'cases_index'
  | 'final'
  | 'case_page'
  | 'guide_page'
  | 'magnet_page';

export const track = {
  ctaClick: (location: CtaLocation) => {
    fire('cta_click', { location });
  },
  formStart: (form: 'lead' | 'lead_magnet' = 'lead') => {
    fire('lp_form_start', { form });
  },
  formSubmit: (params: {
    form: 'lead' | 'lead_magnet';
    segment?: string;
    budget?: string;
    timing?: string;
  }) => {
    fire('lp_form_submit', params);
  },
  formError: (form: 'lead' | 'lead_magnet', errors: string[]) => {
    fire('lp_form_error', { form, errors: errors.join(',') });
  },
  faqOpen: (questionId: string) => {
    fire('faq_open', { question_id: questionId });
  },
  scrollDepth: (percent: 50 | 90) => {
    fire(`scroll_${percent}`);
  },
  themeToggle: (from: string, to: string) => {
    fire('theme_toggle', { from, to });
  },
  leadMagnetDownload: (method: 'direct' | 'email_gate') => {
    fire('lead_magnet_download', { method });
  },
};
